<h1 mat-dialog-title>{{ 'companies.detail.privacyDocsCard.dialog.qrCodeTitle' | translate }}</h1>
<mat-dialog-content id="dataToPrint">
  <div class="row" style="margin-bottom: 10px;" *ngIf="isQrcode">
    <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
      <qrcode id="idQrcodeDataImage" #qrdata [qrdata]="qrcodeData" [width]="150" [errorCorrectionLevel]="'H'" [elementType]="'url'"></qrcode>
    </div>
  </div>
  <div class="row" style="margin-bottom: 10px;" *ngIf="!isQrcode">
    <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
      {{ 'companies.detail.privacyDocsCard.dialog.qrCodeError' | translate }}
    </div>
  </div>
</mat-dialog-content> <!-- mat-dialog-content -->
<div mat-dialog-actions>
  <div class="row w-100 mt-5">
    <div class="col-12 text-right">
      <a mat-button (click)="onSendQrcodeByEmail()" mat-raised-button color="accent" *ngIf="isQrcode"
        class="ml-3"><mat-icon fontSet="fal" fontIcon="fa-envelope" class="mr-1"></mat-icon>{{ 'companies.detail.privacyDocsCard.sendByEmail' | translate }}</a>
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>
